"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGameMicroLayout = void 0;
var useGameMicroLayout_1 = require("./useGameMicroLayout");
Object.defineProperty(exports, "useGameMicroLayout", { enumerable: true, get: function () { return useGameMicroLayout_1.useGameMicroLayout; } });
